import FeatureGates from '@atlaskit/feature-gate-js-client';

export const isTeamBiDirectionalEnabled = () => {
	if (FeatureGates.initializeCompleted()) {
		return FeatureGates.getExperimentValue(
			'team-bi-directional-container-connection',
			'isEnabled',
			false,
			{
				fireExperimentExposure: false,
			},
		);
	}

	return false;
};
